export const iconFontAwesomeTravelHotelBicycle = (
	<i className="fa-solid fa-bicycle"></i>
);
